import styled from 'styled-components'
import { injectModifiers } from 'ui/themes/utils'
import modifiers from 'ui/themes/modifiers'

const Button = styled.button`
  ${({ theme }) => injectModifiers(modifiers(theme))}
`

export default Button
